import React from 'react';
import PropTypes from 'prop-types';

export default function FontCustom({ name, size, className }) {
    const iconStyle = {};
    if(size) {
        iconStyle.fontSize = `${parseFloat(size)}rem`;
    }
    return <i className={`custom-icon-${name} ${className}`} style={iconStyle} />;
}

FontCustom.defaultProps = {
    size: null,
    className: '',
};

FontCustom.propTypes = {
    name: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    className: PropTypes.string,
};
